<template>
  <main>
    <b-row>
      <b-col cols="6" offset="3" class="pt-4 mt-4"> 
        <div class="login-box">
          <a :to="{ name: home }" class="logo"><img src="/images/logo-mynd.svg" alt="Mynd - Context Mining" /></a>
          <h2 class="tagline">Forgot Password</h2>
          <b-form @submit.prevent="submit">
            <b-form-group label="Email" label-for="input-email">
              <b-form-input
                id="input-email"
                type="email"
                v-model="form.email"
                required
                placeholder="Enter your email"
                autocomplete="email"
              ></b-form-input>
            </b-form-group>
            <!--<b-form-group label="Realm (Company)" label-for="input-realm">
              <b-form-input
                id="input-realm"
                v-model="form.realm"
                required
                placeholder="Enter your company/realm"
              ></b-form-input>
            </b-form-group>-->
            <div class="d-flex">
              <b-button :disabled="!form.email || !form.realm" type="submit" variant="primary">Submit</b-button>
              <router-link :to="{ name: 'Login' }" class="sidelink">Back to Login</router-link>
            </div>
          </b-form>
        </div>
      </b-col>
    </b-row>
  </main>
</template>

<script>
import axios from "axios";
export default {
  name: 'Forgot',
  data() {
    return {
      form: {
        email: '',
        realm: 'na'
      }
    };
  },
  mounted() {
    // Try to prefill realm from localStorage
    const company = localStorage.getItem('company');
    if (company) {
      this.form.realm = company;
    }
  },
  methods: {
    async submit() {
      if (!this.form.email || !this.form.realm) return;
      const User = new FormData();
      User.append('email', this.form.email);
      User.append('realm', this.form.realm);
      try {
        const headers = {};
        await axios.post(`/reset_password_url`, User, { headers });
        this.$toasted.show('If the email exists, you will receive instructions to reset your password there.', { type: 'success' });
        setTimeout(() => {
          this.$router.push('/');
        }, 1500);
      } catch (error) {
        let msg = 'An error occurred.';
        if (error.response && error.response.data && error.response.data.detail) {
          msg = error.response.data.detail;
        }
        this.$toasted.show(msg, { type: 'error' });
      }
    }
  }
}
</script>